export default {
  title: 'Nebula buds AI llamada', // "Nebula buds AI通话" 翻译为西班牙语
  userID: 'ID de usuario : ', // "用户ID : "
  hurryUp: 'Esperando la llamada de la otra parte', // "等待对方呼叫"
  waitingCall: 'Esperando la llamada de la otra parte en esta página, por favor no cierre la página prematuramente.', // "在此页面等待对方拨打电话，请勿提前关闭。"
  subSwitch: 'Interruptor de subtítulos', // "字幕开关"
  initWait: 'Esperando la inicialización', // "等待初始化"
  initSuccess: 'Inicialización completada, esperando la llamada de la otra parte. ¡Por favor, no cierre la página!', // "初始化完成，等待对方呼叫。请勿关闭页面！"
  callStart: 'Llamada conectada', // "电话接通"
  callEnd: 'Llamada terminada', // "通话结束"
  careful: 'Atención : ', // "注意 : "
  wait: 'Componente de llamada listo, esperando la llamada de la otra parte', // "通话组件已准备好,等待对方拨打电话"
  langSwitch: {
    ar: 'Árabe', // "阿拉伯语"
    da: 'Danés', // "丹麦语"
    de: 'Alemán', // "德语"
    en: 'Inglés', // "英语"
    es: 'Español', // "西班牙语"
    fil: 'Filipino', // "菲律宾语"
    fr: 'Francés', // "法语"
    hi: 'Hindi', // "印地语"
    id: 'Indonesio', // "印度尼西亚语"
    it: 'Italiano', // "意大利语"
    ja: 'Japonés', // "日文"
    ko: 'Coreano', // "韩语"
    ms: 'Malayo', // "马来语"
    no: 'Noruego', // "挪威语"
    pt: 'Portugués', // "葡萄牙语"
    ru: 'Ruso', // "俄语"
    sv: 'Sueco', // "瑞典语"
    th: 'Tailandés', // "泰语"
    tr: 'Turco', // "土耳其语"
    vi: 'Vietnamita', // "越南语"
    zh: 'Chino' // "中文"
  }
}
